import React from "react";
import "../App.css";
import { Button } from "./Button";
import "./ServiceSection.css";
import { Link } from "react-router-dom";

function ServiceSection() {
  return (
    <div className="service-section">
      <div className="service-content">
        <h1>Our Services</h1>
      </div>
    </div>
  );
}

export default ServiceSection;
